"use strict";
// @ts-ignore
try {
    self['workbox:streams:6.6.0'] && _();
}
catch (e) { }
